module.exports = __webpack_public_path__ + "static/assets/e8092ac373526cf01910e8be1c42b0d5.png";